<template>
  <at-modal
    v-model="showMe"
    :showFooter="false"
    title="Инструкция"
    :styles="{ top: '50px !important', width: '100vw' }"
  >
    <span class="at-modal__back" @click="goBack"
      ><i class="icon icon-chevron-left"></i
    ></span>
    <div class="maindiv">
      <div>
        <p>
          <b>Сетевой электронный словарь вятских говоров</b> (далее - Словарь)
          построен в виде геоинформационной системы.
        </p>
        <p>
          Главный элемент Словаря - <b>Карта</b>. Изначально все районы
          Кировской области включены в поиск слов и окрашены
          <b style="color: #cdcd06">желтым цветом</b>. Кликом мыши по любому
          району его можно исключить из поиска (район становится окрашен <b style="color: #999999">серым
          цветом</b>) и при необходимости новым кликом вернуть район обратно в поиск
          слов.
        </p>
        <p>
          Следующий элемент словаря - <b>Поле поиска</b>. В поле поиска можно
          вводить <b>Диалектные слова</b> (результаты поиска по словам можно
          увидеть сразу при вводе слов), или
          <b>Определения диалектных слов</b> (результат запроса по определениям
          будет виден после нажатия кнопки <i class="icon icon-search" /> или
          клавиши <kbd>Enter</kbd>).
        </p>
        <p>
          Ниже поля поиска находится <b>Окно результатов поиска</b>, в котором
          будет виден список найденных диалектных слов и их определения. После
          клика на любое слово из этого списка:
        </p>
        <ol>
          <li>напротив слова установится галочка;</li>
          <li>
            в правом нижнем углу экрана отобразится полное определение слова;
          </li>
          <li>
            примеры употребления слова будут отображены на <b>Карте</b> в виде
            <b>Маркеров</b>. Кликом по маркеру можно открыть определения слов, а
            также примеры их использования;
          </li>
          <li>слово попадет в <b>Личный словарь пользователя</b>;</li>
        </ol>
        <p>
          Кнопкой <i class="icon icon-sliders" /> поиск можно переключить в
          <b>Расширенный режим</b>. В этом режиме можно отфильтровать для поиска
          только некоторые районы, или некоторые категории слов из Словаря.
          Также расширенный поиск позволяет отобразить в списке слов
          <b>Синонимы</b> к некоторым словам Словаря.
        </p>
        <p>
          <img
            src="/static/lang/img/book.png"
            style="
              width: 80px;
              float: right;
              padding: 6px;
              filter: grayscale(0.5);
            "
          />
          Кнопкой <b>Ваш словарик</b>, находящейся в нижнем левом углу экрана,
          если выключен <b>Расширенный режим</b> поиска, можно вызвать
          <b>Личный словарь пользователя</b>. В этом окне можно:
        </p>
        <ol>
          <li>просмотреть список слов, отмеченных на карте;</li>
          <li>удалить из этого списка одно или несколько слов;</li>
          <li>
            озвучить слово с помощью встроенного в ваш браузер речевого
            синтезатора кликом на определение слова;
          </li>
          <li>
            загрузить список слов на ваш компьютер в виде текстового документа.
          </li>
        </ol>
      </div>
    </div>
  </at-modal>
</template>

<script>
export default {
  data: () => ({
    showMe: true,
  }),
  watch: {
    showMe() {
      if (!this.showMe) this.$router.push({ path: "/" });
    },
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
p,
li {
  text-align: justify;
  font-size: 154% !important;
  font-family: "Century Gothic", sans-serif;
  margin: 6px;
}

b,
i {
  font-family: var(--bs-font-sans-serif);
}

p:first-child:first-letter {
  font-family: "Izhitsa Cyrillic", sans-serif;
  color: rgb(255, 0, 0);
  font-size: 60px;
  line-height: 60px;
  vertical-align: top;
  display: inline-block;
  float: left;
  margin: 0 10px 0 0;
}

.maindiv {
  height: calc(100vh - 118px);
  overflow-y: auto;
  overflow-x: hidden;
  margin: -16px -16px 0px -16px;
  padding-bottom: 20px;
}

.maindiv > div {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
}

@media (max-width: 576px) {
  .maindiv {
  }
}
</style>